import {
	Component,
	OnInit,
	Input,
	SimpleChanges,
	Output,
	EventEmitter,
	OnChanges
} from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-date';
import { Helpers } from 'projects/training-calendar/src/app/helpers';

@Component({
	selector: 'app-date-picker-bootstrap',
	templateUrl: './date-picker-bootstrap.component.html',
	styleUrls: ['./date-picker-bootstrap.component.css']
})
export class DatePickerBootstrapComponent implements OnInit, OnChanges {
	@Input() dateInput: BootStrapDatePicker = {
		required: false,
		placeholder: ''
	};
	@Input() isDisabledNomination: boolean = false;
	@Output() dateChanged = new EventEmitter<any>();
	@Output() blurEvent = new EventEmitter<any>();
	displayError = false;
	model: NgbDateStruct;
	isDisabled: any;
	sundays: number[] = [];
	isSunday: { month: number, day: number[] }[] = [];
	today = new Date();

	constructor() {}

	ngOnInit() {
		//   this.dateInput = {
		// 	placeholder: 'Select Date'
		// }
	}
	onBlur() {
		this.displayError = true;
		this.blurEvent.emit(true);
  	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.dateInput.currentValue) {
			console.log('date inputs', this.dateInput);
			if (typeof this.dateInput.value === 'string') {
				this.dateInput.value = new Date(this.dateInput.value);
			}
			if (this.dateInput.value) {
				this.model = {
					day: this.dateInput.value.getDate(),
					month: this.dateInput.value.getMonth() + 1,
					year: this.dateInput.value.getFullYear()
				};
			} else {
				this.model = changes.dateInput.currentValue.value;
			}
			if (this.dateInput.disabledSunday) {
				// this.getSundaysOfMonth();
				this.getSundays();
			}
		}
	}

	onDateChange() {
		const [day, month, year] = [
			this.model.day < 10 ? `0${this.model.day}` : this.model.day,
			this.model.month < 10 ? `0${this.model.month}` : this.model.month,
			this.model.year
		];
		const selectedDate = Helpers.toDateFromCalendar(`${day}/${month}/${year}`);
		const isoDate = Helpers.toDateFromCalendar(`${day}/${month}/${year}`);
		// console.log(new Date(isoDate.setDate(isoDate.getDate() + 1)).toUTCString());
		console.log(this.model);
		console.log(selectedDate);

		this.dateChanged.emit({
			dateObject: this.model,
			date: selectedDate,
			isoString: isoDate.toISOString()
		});
	}

	// new Date(isoDate.setDate(isoDate.getDate() + 1)).toUTCString()

	getDisabledDates() {
		if (this.dateInput.disabledSunday && this.isSunday.length && !this.dateInput.disabledDates) {
				return (datee: NgbDate, current: { month: number }) =>
					datee.day === this.getDayToDisable1(datee.month, datee.day);
		}
		if (this.dateInput.disabledDates && this.dateInput.disabledDates.length) {
			return (datee: NgbDate, current: { month: number }) =>
					datee.day === this.getDayToDisable2(datee.month, datee.day);
		}
		/**
		 * Old code
		 */
		// if (this.dateInput.disabledSunday && this.sundays.length) {
		// 	return (datee: NgbDate, current: { month: number }) =>
		// 		datee.day === this.getDayToDisable(datee.day);
		// }
		// else if(this.dateInput.futureDate) {
		// 	return (datee: NgbDate, current: {month: number}) => (datee.day < this.dateInput.minDate.day);
		// }
	}

	getDayToDisable2(month, day) {
		const idx = this.dateInput.disabledDates.findIndex(d => d == day);
		if (idx !== -1) {
			return this.dateInput.disabledDates[idx];
		}
	}

	getDayToDisable1(month, day): number {
		const idx = this.isSunday.findIndex(x => x.month === month);
		if (idx !== -1) {
			const sIdx = this.isSunday[idx].day.findIndex(y => y === day);
			if (sIdx !== -1) {
				return this.isSunday[idx].day[sIdx];
			}
		}
	}

	getDayToDisable(day): number {
		const idx = this.sundays.findIndex(x => x === day);
		if (idx !== -1) {
			return this.sundays[idx];
		}
	}

	getSundays() {
		const maxYr = this.dateInput.maxDate ? this.dateInput.maxDate.year : 50;
		for (let year = this.dateInput.minDate.year; year <= maxYr; year++) {
			for (let month = this.dateInput.minDate.month; month < 12; month++) {
				const tdays = new Date(year, month, 0).getDate();
				for (let date = 1; date <= tdays; date++) {
					const data = new Date(
						year,
						month - 1,
						date
					);
					if (data.getUTCDay() === 6) {
						const sIdx = this.isSunday.findIndex(x => x.month === (data.getMonth() + 1));
						if (sIdx === -1) {
							this.isSunday.push({month: (data.getMonth() + 1), day: [data.getDate()]})
						} else {
							this.isSunday[sIdx].day.push(data.getDate());
						}
					}
				}
			}
			console.log('issunday', this.isSunday);
		}
	}

	getSundaysOfMonth() {
		for (
			let i = 0;
			i <=
			new Date(
				this.dateInput.minDate.year,
				this.dateInput.minDate.month,
				0
			).getDate();
			i++
		) {
			const date = new Date(
				this.dateInput.minDate.year,
				this.dateInput.minDate.month - 1,
				i
			);
			if (date.getUTCDay() === 6) {
				this.sundays.push(date.getDate());
			}
			// this.isDisabled = (datee: NgbDate, current: {month: number}) => datee.day === 2;
		}
		console.log(this.sundays);
	}

	onDatePickerClick(datepicker) {
		if (event.target['offsetParent'] && event.target['offsetParent'].classList.contains('dropdown-menu')) {
		 return;
		}
		datepicker.close();
	}
}

export interface BootStrapDatePicker {
	disabled?: boolean;
	readonly?: boolean;
	value?: Date;
	placeholder: string;
	disabledSunday?: boolean;
	disabledNationalHolidays?: boolean;
	dayToDisable?: string;
	minDate?: NgbDateStruct;
	maxDate?: NgbDateStruct;
	futureDate?: boolean;
	rangeDifference?: number;
	required?: boolean;
	errorMessage?: string;
	disabledDates?: any;
}
